// extracted by mini-css-extract-plugin
module.exports = {"navholder":"nav_navholder__TwWae","navbarbrand":"nav_navbarbrand__25a3v"};